import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';

export const baseColumns = [
  {
    id: 'Area',
    mappedKey: 'area',
    messageDescriptor: messages.inventoryLocationArea,
  },
  {
    id: 'Unit',
    mappedKey: 'unit',
    messageDescriptor: messages.inventoryLocationUnit,
  },
  {
    id: 'Shelf',
    mappedKey: 'shelf',
    messageDescriptor: messages.inventoryLocationShelf,
  },
  {
    id: 'Bin',
    mappedKey: 'bin',
    messageDescriptor: messages.inventoryLocationBin,
  },
];

export const baseColumnsWithBarcode = [
  ...baseColumns,
  {
    id: 'Barcode',
    mappedKey: 'barcode',
    messageDescriptor: messages.inventoryLocationBarcode,
  },
];

export const inventoryWarehousePropertyNameOnShipFromObject = 'inventorySourceId';

export class InventoryWarehouseLocationFactory {
  constructor(inventoryWarehouseId) {
    this.inventoryWarehouseId = inventoryWarehouseId;
    this.area = '';
    this.unit = '';
    this.shelf = '';
    this.bin = '';
    this.barcode = '';
    this.isActive = true;
  }
}

export const INVENTORY_WAREHOUSE_ERROR_CODE_MAP = {
  LinkedToShipFroms: 'LinkedToShipFroms',
  ContainsLocations: 'ContainsLocations',
  ContainsStock: 'ContainsStock',
  DuplicateLocation: 'DuplicateInventoryError',
  GenericError: 'GenericError',
  DeleteInventoryLocation: 'DeleteInventoryLocationError',
};
const locationContainsStockDeleteErrorMessage = 'Unable to delete inventory locations with currently assigned inventory';

export const INVENTORY_TOTE_ERROR_CODE_MAP = {
  DuplicateTote: 'ERR_BAD_REQUEST',
};
export const INVENTORY_LOCATION_ERROR_MESSAGE_MAP = {
  LocationContainsStock: <FormattedMessage {...messages.inventoryLocationDeleteErrorContainsStock} />,
  DuplicateLocation: <FormattedMessage {...messages.inventoryWarehouseDuplicateLocationNotificationContent} />,
};

export const INVENTORY_WAREHOUSE_ERROR_MESSAGE_MAP = {
  [INVENTORY_WAREHOUSE_ERROR_CODE_MAP.LinkedToShipFroms]: <FormattedMessage {...messages.inventoryWarehouseDeleteErrorLinkedToShipFroms} />,
  [INVENTORY_WAREHOUSE_ERROR_CODE_MAP.ContainsLocations]: <FormattedMessage {...messages.inventoryWarehouseDeleteErrorContainsLocations} />,
  [INVENTORY_WAREHOUSE_ERROR_CODE_MAP.ContainsStock]: <FormattedMessage {...messages.inventoryWarehouseDeleteErrorContainsStock} />,
  [INVENTORY_WAREHOUSE_ERROR_CODE_MAP.DuplicateLocation]: <FormattedMessage {...messages.inventoryWarehouseDeleteErrorContainsStock} />,
};

export const getWarehouseOrLocationOrToteErrorMessage = (error) => {
  if (error?.code === INVENTORY_WAREHOUSE_ERROR_CODE_MAP.DuplicateLocation) {
    return INVENTORY_LOCATION_ERROR_MESSAGE_MAP.DuplicateLocation;
  }
  if (error?.code === INVENTORY_WAREHOUSE_ERROR_CODE_MAP.DeleteInventoryLocation) {
    return error.message === locationContainsStockDeleteErrorMessage
      ? [INVENTORY_LOCATION_ERROR_MESSAGE_MAP.LocationContainsStock]
      : [INVENTORY_LOCATION_ERROR_MESSAGE_MAP.DuplicateLocation];
  }
  if (error?.code === INVENTORY_TOTE_ERROR_CODE_MAP.DuplicateTote) {
    return <FormattedMessage {...messages.inventoryWarehouseToteDuplicateError} />;
  }
  return INVENTORY_WAREHOUSE_ERROR_MESSAGE_MAP[error] || <FormattedMessage {...messages.inventoryWarehouseGenericError} />;
};

export const MAX_TOTES = 99;
